export default {
  nav: {
    home: 'Home',
    aboutUs: 'About Us',
    facilities: 'Facilities',
    certification: 'Certification',
    portofolio: 'Portofolio',
    service: 'Service',
    career: 'Career',
    newsBlog: 'News & Blog',
    factoryTour: 'Factory Tour',
    seminar: 'Seminar',
    contactUs: 'Contact Us',
  },
  footer: {
    copyright: 'PT. TOKKI ENGINEERING AND FABRICATION',
  },
  languageSwitcher: {
    label: 'Bahasa',
    id: 'Indonesia',
    en: 'Inggris',
    ja: 'Jepang',
  },
  offices: {
    motoStartWithTokki: 'bersama TOKKI',
    mainOfficeFactory: 'Kantor & Pabrik Utama',
    secondOfficeFactory: 'Kantor & Pabrik ke-2',
    thirdOfficeFactory: 'Kantor & Cabang ke-3',
    fourthMarketingOffice: 'Kantor Perwakilan ke-4',
    readMore: 'Baca Selengkapnya',
    ourHappyClient: 'Klien Kami yang Puas',
    majorCustomerIn: 'Pelanggan Utama di',
    productServices: 'Produk / Layanan',
  },
};
